import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/_services/app.service';
import { CommonModalComponent } from '../common/common-modal/common-modal.component';
import { DialogComponent } from '../masters/dialog/dialog.component';

@Component({
  selector: 'app-all-action',
  templateUrl: './all-action.component.html',
  styleUrls: ['./all-action.component.scss']
})
export class AllActionComponent implements OnInit {

  @Input() docList: any;
  @Input() pageName: any;

  constructor(
    private dialog: MatDialog,
    private service: AppService
  ) { }

  ngOnInit(): void {
  }

  deleteDoc() {
    console.log(this.docList);
    const dialogRef = this.dialog.open(CommonModalComponent, {
      width: '300px',
      disableClose: true,
      autoFocus: false,
      panelClass: 'statusClass',
      data: { action: 'delete', statusText: 'Are you sure you want to delete record' }
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const a = this.docList.filter(x => x.is_selected);
        const DocumentIds = a.map(x => x.documentId);
        this.service.postService({ DocumentIds }, 'Document/DocumentDelete').subscribe(response => {
          if (response.body.success) {
            $('#table1').DataTable().ajax.reload();
            this.service.alertPopup('success', response.body.result.transactionMessage.message);
          } else {
            this.service.alertPopup('delete', response.body.result.transactionMessage.message);
          }
        })
      }
    });
  }
  shareFile() {
    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: 'modal-width',
      autoFocus: false,
      data: { action: 'shareFile', data: this.docList, type: 'multiple' }
    })
  }
}
